import React, {useContext} from 'react'
import { AppBar, Toolbar, Button, IconButton } from '@mui/material'
import LogoutIcon from '@mui/icons-material/Logout';
import { Context } from '../App';
import logo from '../asset/pictures/logo_thyba.png';

export default function Header(props) {
    const { updateConnect } = useContext(Context)

    function handleLogout() {
        sessionStorage.clear()
        updateConnect(false)
    }

    return(
        <AppBar position='sticky' sx={{height:'70px'}}>
            <Toolbar sx={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <a href='/' style={{textDecoration:'none', marginTop:'5px'}}>
                    <img src={logo} alt='logo' style={{width:'143px', height:'80px'}} />
                </a>
                <IconButton
                color='inherit'
                onClick={handleLogout}>
                    <LogoutIcon />
                </IconButton>
            </Toolbar>
        </AppBar>
    )
}